import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.css']
})
export class PrivacyNoticeComponent implements OnInit {
  ShowEU: any;
  SHowAPAC: any;
  Language: string;
  constructor(private router: Router) {}

  ngOnInit() {
    this.Language = window.location.href;
    if (this.Language.indexOf('/cn/') !== -1 || this.Language.indexOf('/tw/') !== -1 || this.Language.indexOf('/hk/') !== -1
    || this.Language.indexOf('/jp/') !== -1) {
      this.ShowEU = 'none';
      this.SHowAPAC = 'block';
    } else {
      this.ShowEU = 'block';
      this.SHowAPAC = 'none';
    }
    console.log(window.location.href);
    console.log(this.ShowEU);
    console.log(this.SHowAPAC);
  }

}
